import React from 'react';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { locales } from '~/utils';
import { formatFloatNumber } from '~/utils/formatter';

const ButtonSubscribe = ({ t, onClick, lng }) => {
  let customStyle = {};

  if (lng === 'tw') {
    customStyle = { padding: '10px 30px' };
  }

  return (
    <button
      type="button"
      className={`btn btn-ac-primary btn-${Config.serviceType} btn-subcribe`}
      style={customStyle}
      onClick={onClick}
    >
      {t('subcribe_now')}
    </button>
  );
};

const GroupSites = ({ lng, t }) => {
  const listDomain = Config.getListDomain(lng);
  const acWebsites = [
    {
      site: 'photo_ac',
      link: listDomain.PHOTO_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/photo.png`,
      text_logo: t('free_stock_photos_ac'),
    },
    {
      site: 'illust_ac',
      link: listDomain.ILLUST_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/illust_old.png`,
      text_logo: t('free_vector_clip_art'),
    },
    {
      site: 'silhouette_ac',
      link: listDomain.SILHOUETTE_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/silhouette.png`,
      text_logo: t('free_vector_silhouettes'),
    },
    {
      site: 'design_ac',
      link: listDomain.DESIGN_AC,
      logo: `${Config.staticPrefix}/static/assets/image/logo/logo_design_ac.png`,
      text_logo: t('free_design_templates'),
    },
  ];
  return (
    <div>
      <div className="group-websites-plan-box-title">
        <span>{t('premium_apply_group_sites')}</span>
      </div>
      <div className="dashed-line" />
      <div className="group-websites-plan-box">
        {acWebsites.map((item) => (
          <a
            href={item.link}
            target="_blank"
            className={`website-item ${item.site}`}
            rel="noreferrer"
          >
            <img
              className={`website-logo ${item.site}`}
              src={item.logo}
              alt={item.text_logo}
            />
          </a>
        ))}
      </div>
    </div>
  );
};

const PreviousMonthlyPrice = ({ currencyIcon, currencyName, price, t }) => (
  <>
    <span
      className={`price ${Config.getPrefixContent(
        'price-color',
      )} original-price`}
    >
      {`${currencyIcon}${price} ${currencyName}`}
      <small>/{t('Month')}</small>
    </span>
  </>
);

const CurrentMonthlyPrice = ({
  currencyIcon,
  currencyName,
  price,
  t,
  className,
}) => (
  <span
    className={`price ${Config.getPrefixContent('price-color')} ${className}`}
  >
    <strong>{`${currencyIcon}${price} ${currencyName}`}</strong>
    <small>/{t('Month')}</small>
  </span>
);

const PreviousYearlyPrice = ({ currencyIcon, currencyName, price, t }) => (
  <span className="info original-price">
    {`${currencyIcon}${price} ${currencyName}`}
    <span
      dangerouslySetInnerHTML={{
        __html: t('every_12_months'),
      }}
    />
  </span>
);

const CurrentYearlyPrice = ({
  currencyIcon,
  currencyName,
  price,
  t,
  timeByMonthsTitle,
  className,
}) => (
  <span
    // className={`info ${className}`}
    className={`price ${Config.getPrefixContent('price-color')} ${className}`}
  >
    <b>{`${currencyIcon}${price} ${currencyName} `}</b>
    <span
      dangerouslySetInnerHTML={{
        __html: t(timeByMonthsTitle),
      }}
    />
  </span>
);

const SinglePricePremiumBoxContent = ({
  t,
  onSubscribe,
  monthlyPrice,
  mainPrice,
  discountedMonthlyPrice,
  discountedMainPrice,
  currencyIcon,
  currencyName,
  lng,
  type,
}) => {
  let titleBox;
  let timeByMonthsTitle;
  let isBestPrice;
  if (type === 'ONE_YEAR') {
    titleBox = 'one_year_plan';
    timeByMonthsTitle = 'every_12_months';
    isBestPrice = true;
  } else if (type === 'TWO_YEAR') {
    titleBox = 'two_year_plan';
    timeByMonthsTitle = 'every_24_months';
  } else {
    titleBox = 'three_year_plan';
    timeByMonthsTitle = 'every_36_months';
  }
  return (
    <div className="plan-box">
      <div className="plan-price">
        <div className="box-left">
          {onSubscribe && isBestPrice && (
            <span className={`badge ${Config.getPrefixContent('badge')}`}>
              {t('best_plan')}
            </span>
          )}
          <div className="content">
            <span className="title">{t(titleBox)}</span>
            {/* {discountedMonthlyPrice ? (
              <>
                <CountdownTimer />
                <span className="register-hint">
                  ※{t('register_now_to_keep_plan')}
                </span>
                <PreviousMonthlyPrice
                  currencyIcon={currencyIcon}
                  currencyName={currencyName}
                  price={monthlyPrice}
                  t={t}
                />
                <CurrentMonthlyPrice
                  className="discounted-price"
                  currencyIcon={currencyIcon}
                  currencyName={currencyName}
                  price={discountedMonthlyPrice}
                  t={t}
                />
              </>
            ) : (
              <CurrentMonthlyPrice
                currencyIcon={currencyIcon}
                currencyName={currencyName}
                price={monthlyPrice}
                t={t}
              />
            )} */}
            {/* {discountedMainPrice ? (
              <>
                <PreviousYearlyPrice
                  currencyIcon={currencyIcon}
                  currencyName={currencyName}
                  price={mainPrice}
                  t={t}
                />
                <CurrentYearlyPrice
                  className="discounted-price"
                  currencyIcon={currencyIcon}
                  currencyName={currencyName}
                  price={discountedMainPrice}
                  t={t}
                  timeByMonthsTitle={timeByMonthsTitle}
                />
              </> */}
            {/* ) : ( */}
            <CurrentYearlyPrice
              currencyIcon={currencyIcon}
              currencyName={currencyName}
              price={mainPrice}
              t={t}
              timeByMonthsTitle={timeByMonthsTitle}
            />
            {/* )} */}
          </div>
        </div>
        <div className="box-right">
          {onSubscribe && (
            <ButtonSubscribe t={t} onClick={onSubscribe} lng={lng} />
          )}
        </div>
      </div>
      <div className="plan-benefit">
        {onSubscribe && <GroupSites t={t} lng={lng} />}
      </div>
    </div>
  );
};

const SinglePricePremiumPlanBox = withI18next()((props) => {
  const {
    currentSinglePremium,
    t,
    onRegisterPremium,
    isMonthLyAtDesign,
    lng,
    displayAtPaymentModal,
  } = props;
  const monthlyPrice = formatFloatNumber(
    locales.roundPriceByCurrency('CNY', currentSinglePremium.monthlyConversion),
  );
  const mainPrice = formatFloatNumber(
    locales.roundPriceByCurrency('CNY', currentSinglePremium.price),
  );
  let handler = () => onRegisterPremium(currentSinglePremium);
  let discountedMonthlyPrice;
  let discountedMainPrice;
  console.log('discountedddddd', currentSinglePremium.discounted);
  if (currentSinglePremium.discounted) {
    discountedMainPrice = formatFloatNumber(
      locales.roundPriceByCurrency(
        'CNY',
        currentSinglePremium.discounted.price,
      ),
    );
    discountedMonthlyPrice = formatFloatNumber(
      locales.roundPriceByCurrency(
        'CNY',
        currentSinglePremium.discounted.monthlyConversion,
      ),
    );
    handler = () => onRegisterPremium(currentSinglePremium.discounted);
  }
  if (displayAtPaymentModal) handler = null;

  return (
    <>
      <div
        className="premium-plan-box"
        style={
          displayAtPaymentModal
            ? {
                textAlign: 'center',
              }
            : isMonthLyAtDesign
            ? {
                padding: '31px 0px',
              }
            : null
        }
        onClick={handler}
      >
        <SinglePricePremiumBoxContent
          t={t}
          lng={lng}
          monthlyPrice={monthlyPrice}
          mainPrice={mainPrice}
          discountedMonthlyPrice={discountedMonthlyPrice}
          discountedMainPrice={discountedMainPrice}
          type={currentSinglePremium.type}
          onSubscribe={handler}
          currencyName="CNY"
          currencyIcon="¥"
        />
        <style jsx global>
          {`
            .premium-plan-box:hover {
              border: 1px solid #9bafbf;
            }

            .premium-plan-box {
              border: 1px solid #e5edef;
              border-radius: 2px;
              background: #fff;
              box-shadow: 0 1px 5px rgba(134, 159, 178, 0.6);
              background-image: -webkit-linear-gradient(
                15deg,
                transparent 76%,
                #eeeef0 77%
              );
              margin: 0 0 1.5em;
              cursor: pointer;
            }
            .premium-plan-box .plan-box {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              padding-top: 19px;
            }
            .premium-plan-box .plan-box .plan-price {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
            }
            .premium-plan-box .plan-box .plan-price .box-left {
              width: 100%;
            }
            .premium-plan-box .plan-box .plan-price .box-left .register-hint {
              font-style: italic;
              font-size: 12px;
            }
            .premium-plan-box .plan-box .plan-price .box-left .badge {
              position: relative;
              display: inline-block;
              min-width: 50%;
              height: 24px;
              padding: 0 0 0 1.5em;
              border: none;
              border-radius: 0;
              font-size: 0.875em;
              font-weight: 400;
              line-height: 24px;
              text-align: left;
            }
            .premium-plan-box .plan-box .plan-price .box-left .ill_badge {
              background: #d73a4e;
            }
            .premium-plan-box .plan-box .plan-price .box-left .sil_badge {
              background: #41b9b8;
            }
            .premium-plan-box .plan-box .plan-price .box-left .photo_badge {
              background: #4c9ade;
            }
            .premium-plan-box .plan-box .plan-price .box-left .design_badge {
              background: #ffa823;
            }
            .premium-plan-box .plan-box .plan-price .box-left .badge:after {
              position: absolute;
              top: 50%;
              right: -12px;
              transform: translateY(-50%) rotate(45deg);
              width: 24px;
              height: 24px;
              background: #fff;
              content: '';
            }
            .premium-plan-box .plan-box .plan-price .box-left .content {
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              padding: 0.5em 0px 1.5em 1.5em;
            }
            .premium-plan-box .plan-box .plan-price .box-left .content .title {
              font-size: 1em;
              font-weight: 700;
              text-transform: uppercase;
            }
            .premium-plan-box .plan-box .plan-price .box-left .content .price {
              margin-top: 14px;
              font-size: 2em;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .photo_price-color {
              color: #4c9ade;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .ill_price-color {
              color: #d73a4e;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .sil_price-color {
              color: #41b9b8;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .design_price-color {
              color: #ffa823;
            }
            .premium-plan-box .plan-box .plan-price .box-left .content .info {
              margin-top: 14px;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .discounted-price {
              margin-top: 0px;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .original-price {
              text-decoration: line-through;
              font-weight: normal;
              color: #3e3e3f;
            }
            .premium-plan-box
              .plan-box
              .plan-price
              .box-left
              .content
              .original-price
              b {
              font-weight: normal;
            }
            .premium-plan-box .plan-box .plan-price .box-right {
              padding-right: 1.5em;
              padding-top: 100px;
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              align-items: flex-end;
            }
            .premium-plan-box .plan-box .plan-price .box-right .btn-subcribe {
              padding: 10px;
            }
            .premium-plan-box .plan-box .plan-benefit {
              padding: 0.5em 0px 1.5em 1.5em;
            }
            .premium-plan-box .plan-box .plan-benefit .dashed-line {
              border: dashed 0.5px #3e3e3f;
              margin: 0.5em 1.5em 0.5em 0em;
            }
            .premium-plan-box .plan-box .plan-benefit .group-websites-plan-box {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
            }
            .premium-plan-box
              .plan-box
              .plan-benefit
              .group-websites-plan-box
              a {
              padding: 0px 35px 0px 0px;
            }
            .premium-plan-box
              .plan-box
              .plan-benefit
              .group-websites-plan-box
              .website-item {
              cursor: pointer;
            }
            .premium-plan-box
              .plan-box
              .plan-benefit
              .group-websites-plan-box
              .website-item.photo_ac {
              margin-top: 5px;
            }
            .premium-plan-box
              .plan-box
              .plan-benefit
              .group-websites-plan-box
              .website-logo {
              width: auto;
              height: 23px;
            }
            .premium-plan-box
              .plan-box
              .plan-benefit
              .group-websites-plan-box
              .website-logo.design_ac {
              height: 28px;
            }
          `}
        </style>
      </div>
    </>
  );
});

export default SinglePricePremiumPlanBox;
